(() => {
  const selectors = {
    combinedProductListItem: '.js-combined-product-list-item',
    productSectionWrapper: '.product-section-wrapper',
    variantButtonLabel: '.variant__button-label',
    productSectionWrapperHiddenClass: 'product-section-wrapper--hidden',
    productSectionWrapperVisibleClass: 'product-section-wrapper--visible',
    sizeGuideTrigger: '.product-section__size-guide-trigger',
    sizeGuideTriggerCombinedProduct: '.product-section__size-guide-trigger--combined-product',
  }


  const changeCombinedProduct = (productId, valueId) => {
    const activeProduct = document.querySelector(`${selectors.productSectionWrapper}:not(.${selectors.productSectionWrapperHiddenClass})`);
    const currentProduct = document.querySelector(`${selectors.productSectionWrapper}[data-product-id="${productId}"]`);
    const currentVariant = document.querySelector(`${selectors.variantButtonLabel}[data-value-id="${valueId}"]`);

    if (currentProduct && activeProduct) {
      if (currentVariant) {
        currentVariant.click();
      }

      setTimeout(() => {
        currentProduct.classList.remove(selectors.productSectionWrapperHiddenClass);
        activeProduct.classList.add(selectors.productSectionWrapperHiddenClass);
        window.initGalleryFilter();
      }, 100);
    }
  };

  const openMainSizeGuide = () => {
    const sizeGuideTrigger = document.querySelector(`${selectors.sizeGuideTrigger}:not(${selectors.sizeGuideTriggerCombinedProduct})`);

    if (sizeGuideTrigger) {
      sizeGuideTrigger.click();
    }
  };

  const initListeners = () => {
    const combinedProductListItems = document.querySelectorAll(selectors.combinedProductListItem);
    const sizeGuideTriggerCombinedProduct = document.querySelector(selectors.sizeGuideTriggerCombinedProduct);

    combinedProductListItems.forEach(item => {
      item.addEventListener('click', function() {
        changeCombinedProduct(item.dataset.productId, item.dataset.valueId);
      });
    });

    sizeGuideTriggerCombinedProduct.addEventListener('click', openMainSizeGuide);
  };

  initListeners();
})();
